(function () {
  'use strict';

  const AQUAFIL_VARIANT_ID = '45786904625344';
  const GLYCOSHINE_VARIANT_ID = '45786891288768';

  const OFFER_FLAG = 'skinverse_aquafil_offer_active';

  let syncing = false;
  let lastCartSignature = '';

  /*
   * ------------------------------------------------------------
   * 1. ACTIVATE THE OFFER WHEN CUSTOMER IS ON THE OFFER PAGE
   * ------------------------------------------------------------
   */

  if (
    window.location.pathname === '/pages/aquafil-hydration-offer'
  ) {
    sessionStorage.setItem(OFFER_FLAG, 'true');
  }

  function offerIsActive() {
    return sessionStorage.getItem(OFFER_FLAG) === 'true';
  }

  /*
   * ------------------------------------------------------------
   * 2. READ CURRENT CART
   * ------------------------------------------------------------
   */

  async function getCart() {
    const response = await fetch('/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store'
    });

    if (!response.ok) {
      throw new Error('Unable to read Shopify cart.');
    }

    return response.json();
  }

  /*
   * ------------------------------------------------------------
   * 3. REFRESH THE EXISTING SHOPIFY CART DRAWER
   * ------------------------------------------------------------
   */

  function refreshCartDrawer(parsedState) {
    const cartDrawer = document.querySelector('cart-drawer');

    if (
      cartDrawer &&
      typeof cartDrawer.renderContents === 'function' &&
      parsedState &&
      parsedState.sections
    ) {
      cartDrawer.renderContents(parsedState);
    }
  }

  /*
   * ------------------------------------------------------------
   * 4. ADD GLYCOSHINE AND REFRESH CART DRAWER
   * ------------------------------------------------------------
   */

  async function addGlycoshine(quantity) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(GLYCOSHINE_VARIANT_ID),
            quantity: quantity
          }
        ],
        sections: [
          'cart-drawer',
          'cart-icon-bubble'
        ],
        sections_url: window.location.pathname
      })
    });

    if (!response.ok) {
      throw new Error('Unable to add GlycoShine to cart.');
    }

    const parsedState = await response.json();

    refreshCartDrawer(parsedState);

    return parsedState;
  }

  /*
   * ------------------------------------------------------------
   * 5. CHANGE GLYCOSHINE QUANTITY AND REFRESH CART DRAWER
   * ------------------------------------------------------------
   */

  async function changeGlycoshine(glycoshineKey, quantity) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: glycoshineKey,
        quantity: quantity,
        sections: [
          'cart-drawer',
          'cart-icon-bubble'
        ],
        sections_url: window.location.pathname
      })
    });

    if (!response.ok) {
      throw new Error('Unable to update GlycoShine quantity.');
    }

    const parsedState = await response.json();

    refreshCartDrawer(parsedState);

    return parsedState;
  }

  /*
   * ------------------------------------------------------------
   * 6. SYNC GLYCOSHINE WITH AQUAFIL QUANTITY
   * ------------------------------------------------------------
   */

  async function syncAquafilGift() {
    if (syncing || !offerIsActive()) {
      return;
    }

    syncing = true;

    try {
      const cart = await getCart();

      let aquafilQuantity = 0;
      let glycoshineQuantity = 0;
      let glycoshineItem = null;

      cart.items.forEach(function (item) {
        if (String(item.variant_id) === AQUAFIL_VARIANT_ID) {
          aquafilQuantity += item.quantity;
        }

        if (String(item.variant_id) === GLYCOSHINE_VARIANT_ID) {
          glycoshineQuantity += item.quantity;
          glycoshineItem = item;
        }
      });

      /*
       * --------------------------------------------------------
       * AQUAFIL = 0
       * → REMOVE GLYCOSHINE
       * --------------------------------------------------------
       */

      if (aquafilQuantity === 0) {
        if (glycoshineItem && glycoshineQuantity > 0) {
          await changeGlycoshine(
            glycoshineItem.key,
            0
          );
        }

        return;
      }

      /*
       * --------------------------------------------------------
       * AQUAFIL > GLYCOSHINE
       * → ADD THE DIFFERENCE
       * --------------------------------------------------------
       */

      if (aquafilQuantity > glycoshineQuantity) {
        const quantityToAdd =
          aquafilQuantity - glycoshineQuantity;

        await addGlycoshine(quantityToAdd);

        return;
      }

      /*
       * --------------------------------------------------------
       * GLYCOSHINE > AQUAFIL
       * → REDUCE GLYCOSHINE
       * --------------------------------------------------------
       */

      if (
        aquafilQuantity < glycoshineQuantity &&
        glycoshineItem
      ) {
        await changeGlycoshine(
          glycoshineItem.key,
          aquafilQuantity
        );
      }

    } catch (error) {
      console.error(
        'Skinverse Aquafil Offer:',
        error
      );
    } finally {
      syncing = false;
    }
  }

  /*
   * ------------------------------------------------------------
   * 7. WATCH FOR CART CHANGES
   * ------------------------------------------------------------
   */

  async function watchCart() {
    if (!offerIsActive() || syncing) {
      return;
    }

    try {
      const cart = await getCart();

      const signature = cart.items
        .map(function (item) {
          return (
            item.key +
            ':' +
            item.quantity
          );
        })
        .join('|');

      if (signature !== lastCartSignature) {
        lastCartSignature = signature;

        await syncAquafilGift();
      }

    } catch (error) {
      console.error(
        'Skinverse Aquafil Cart Watcher:',
        error
      );
    }
  }

  /*
   * ------------------------------------------------------------
   * 8. INITIAL CHECK
   * ------------------------------------------------------------
   */

  async function init() {
    if (!offerIsActive()) {
      return;
    }

    await syncAquafilGift();

    /*
     * Safety net for Shopify/theme cart updates.
     */

    setInterval(watchCart, 500);
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }

})();